module.exports = __webpack_public_path__ + "static/media/inf_19og20.c541e654.mp3";